export function ripostes(state) {
    return (state.targetId === null &&
        state.pathLength === 0 &&
        state.pickupId === null &&
        !state.riding &&
        !state.dead &&
        !state.away);
}
//# sourceMappingURL=riposte.js.map